import React from "react";
import "./StatsSection.css";

const stats = [
  
  {
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"></circle>
        <circle cx="12" cy="12" r="4"></circle>
        <line x1="12" y1="2" x2="12" y2="6"></line>
        <line x1="12" y1="18" x2="12" y2="22"></line>
        <line x1="2" y1="12" x2="6" y2="12"></line>
        <line x1="18" y1="12" x2="22" y2="12"></line>
      </svg>
    ),
    value: "99.9%",
    label: "PICK ACCURACY",
  },
  {
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M19.439 7.85c-.049.322.059.648.289.878l1.568 1.568c.47.47.706 1.087.706 1.704s-.235 1.233-.706 1.704l-1.611 1.611a.98.98 0 0 1-.837.276c-.47-.07-.952.151-1.258.56-.308.411-.36.963-.12 1.439l.83 1.659c.28.56.28 1.213 0 1.773-.28.561-.79.95-1.41.107l-2.22-2.22a.994.994 0 0 0-1.4 0l-1.6 1.6a2.413 2.413 0 0 1-3.41 0l-1.6-1.6a.994.994 0 0 0-1.4 0l-2.22 2.22c-.62.843-1.13.454-1.41-.107-.28-.56-.28-1.213 0-1.773l.83-1.659c.24-.476.188-1.028-.12-1.439-.306-.409-.788-.63-1.258-.56a.98.98 0 0 1-.837-.276L2 15.3c-.47-.47-.706-1.087-.706-1.704s.235-1.233.706-1.704l1.568-1.568c.23-.23.338-.556.289-.878-.05-.333-.217-.63-.473-.836l-1.57-1.257C1.408 6.786 1.157 6.136 1.258 5.48c.101-.655.51-1.22 1.136-1.564l1.986-1.092a1.006 1.006 0 0 1 1.18.156l1.248 1.248c.365.365.918.472 1.4.28.483-.19.82-.628.887-1.144l.214-1.637C9.394 1.042 9.94.526 10.63.43c.69-.095 1.37.228 1.768.842l1.21 1.86a.992.992 0 0 0 1.066.425c.414-.117.78-.396.993-.762l.858-1.46c.355-.606 1.01-.95 1.706-.897.696.052 1.3.473 1.575 1.09l1.043 2.348a1.002 1.002 0 0 1-.365 1.164l-1.373 1.006c-.347.254-.538.665-.506 1.09.032.426.286.8.675.986l1.644.785c.613.293 1.033.856 1.15 1.542.118.687-.11 1.392-.625 1.93z"></path>
      </svg>
    ),
    value: "650+",
    label: "INTEGRATIONS",
  },
  {
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <rect x="1" y="3" width="15" height="13"></rect>
        <polygon points="16 8 20 8 23 11 23 16 16 16 16 8"></polygon>
        <circle cx="5.5" cy="18.5" r="2.5"></circle>
        <circle cx="18.5" cy="18.5" r="2.5"></circle>
      </svg>
    ),
    value: "24H",
    label: "DISPATCH",
  },
  {
    icon: (
      <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z"></path>
        <line x1="7" y1="7" x2="7.01" y2="7"></line>
      </svg>
    ),
    value: "From 30p",
    label: "FBA PREP / UNIT",
  },
];

const StatsSection: React.FC = () => {
  return (
    <section className="stats-section" aria-label="Pick Pack Pro key statistics">
      <div className="stats-container">
        <div className="stats-banner" role="list">
          {stats.map((stat, index) => (
            <React.Fragment key={index}>
              <div className="stats-item" role="listitem">
                <div className="stats-icon">{stat.icon}</div>
                <div className="stats-text-block">
                  <div className="stats-value" >{stat.value}</div>
                  <div className="stats-label" >{stat.label}</div>
                </div>
              </div>
              {index < stats.length - 1 && <div className="stats-separator"></div>}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
};

export default StatsSection;

